

import React, { useState,useEffect,useCallback ,useMemo,useLayoutEffect,useRef } from 'react';
import ModalAllder from 'components/layout/ModalAllder';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import AllderTable from 'components/layout/AllderTable';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';

export default function ModalSelectMultipleProduct({modal,setModal,productRow,setProductRow,addProductRow,...props}){

    const [data, setData] = useState(productList);

    const columnsd = [
        { 
            field: 'productCode', 
            headerName: 'รหัสสินค้า', width: 160,
            sortable: false,
            renderCell: ({ row }) => (<div><div style={{color:'#565DFF'}}>{row.productCode}</div></div>)
        },
        {
          field: 'productName',
          headerName: 'ชื่อสินค้า',
          width: 250,
          sortable: false,
          renderCell: ({ row }) => (<div><div>{row.productName}<br/><span className='fs-12' style={{color:'#F26F3A'}}>{row.productBarcode}</span> </div></div>)
        },
        {
          field: 'productCategory',
          headerName: 'หมวดหมู่',
          width: 150,
          sortable: false,
        },
        {
          field: 'productPrice',
          headerName: 'ราคาขาย',
          width: 110,
          sortable: false,
        },
        {
          field: 'productUnit',
          headerName: 'หน่วย',
          sortable: false,
          width: 160,
        },
        {
          field: 'productRatio',
          headerName: 'อัตตราส่วน',
          width: 110,
          sortable: false,
        }
    ];

    const [filterText, setFilterText] = useState('');

    let filteredItems =  data.filter(
        item => item.productCode && item.productCode.toLowerCase().includes(filterText.toLowerCase()) 
        || item.productName && item.productName.toLowerCase().includes(filterText.toLowerCase()) 
        
    );

    const [productType, setProductType] = useState('');
    const productTypeOption = [
        { value: 1,label: 'ประเภท 1'},
    ]
    const [productCategory, setProductCategory] = useState('');
    const productCategoryOption = [
        { value: 1,label: 'หมวด 1 '},
    ]

    const [productBrand, setProductBrand] = useState('');
    const productBrandOption = [
        { value: 1,label: 'แบรนด์สินค้า 1 '},
    ]


    const [search, setSearch] = useState(1);
    const searchOption = [
        { value: 1,label: 'ทั้งหมด'},
    ]
    


    return (
        <>

            <ModalAllder  
                modal={modal} 
                setModal={setModal}  
                htitle={"เพิ่มสินค้าหลายรายการ"} 
                hbtn={true}
            >
                <div>

                    <Box sx={{  width: '100%' }}>

                        <div className="grid grid-cols-11 gap-4 mb-4">
                            <div className='col-span-2'> 
                                <TextField  
                                    select
                                    label="ประเภทสินค้า" 
                                    variant="outlined"  
                                    name='productType'
                                    value={productType}
                                    onChange={(e) => {
                                        setProductType(e.target.value)
                                    }}
                                >
                                    {productTypeOption.map((option) => (
                                        <MenuItem key={option.value} value={option.value} >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            
                            <div className='col-span-9'></div>
                            
                            <div className='col-span-2'> 
                                <TextField  
                                    select
                                    label="หมวดหมู่" 
                                    variant="outlined"  
                                    name='productCategory'
                                    value={productCategory}
                                    onChange={(e) => {
                                        setProductCategory(e.target.value)
                                    }}
                                >
                                    {productCategoryOption.map((option) => (
                                        <MenuItem key={option.value} value={option.value} >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>

                            </div>
                            <div className='col-span-2'> 

                                <TextField  
                                    select
                                    label="แบรนด์สินค้า" 
                                    variant="outlined"  
                                    name='productBrand'
                                    value={productBrand}
                                    onChange={(e) => {
                                        setProductBrand(e.target.value)
                                    }}
                                >
                                    {productBrandOption.map((option) => (
                                        <MenuItem key={option.value} value={option.value} >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className='col-span-1'> 
                            </div>

                            <div className='col-span-2'> 

                                <TextField  
                                    select
                                    label="ตัวเลือกการค้นหา" 
                                    variant="outlined"  
                                    name='search'
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value)
                                    }}
                                >
                                    {searchOption.map((option) => (
                                        <MenuItem key={option.value} value={option.value} >
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className='col-span-2'> 
                                <TextField  
                                    label="ค้นหา" 
                                    variant="outlined"  
                                    placeholder='ค้นหารหัสสินค้า'
                                    name="refer"
                                    value={filterText}
                                    onChange={(e) => {
                                        setFilterText(e.target.value)
                                    }}
                                    
                                />
                            </div>
                            <div className='col-span-2'> 
                                <Button variant="outlined" color='blue3' size='large'
                                    onClick={() => {
                                        setFilterText('')
                                        setProductBrand('')
                                        setProductType('')
                                        setSearch(1)
                                  
                                    }}
                                >ล้างค่าการค้นหา</Button>
                            </div>
                        </div>


                        <AllderTable
                            getRowId={(row) => row.productID}
                            getRowHeight={() => 'auto'}
                            rows={filteredItems}
                            autoHeight={true}
                            columns={columnsd}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5,10,15]}
                            checkboxSelection
                            disableRowSelectionOnClick
                            slotProps={{ pagination: { labelRowsPerPage: 'จำนวนรายการต่อหน้า' } }}
                            disableMultipleRowSelection={true}
                            onRowSelectionModelChange={(ids) => {
                                const selectedIDs = new Set(ids);
                                const selectedRows = filteredItems.filter((row) => selectedIDs.has(row.productID));
                                if(selectedRows.length > 0){
                                
                                    const emptyRow = productRow.filter((row) => !row.productCode  );
                                    if(emptyRow.length > 0){
                                    
                                        setProductRow(productRow => productRow.map((el) => {
                                            if (el.rowID == emptyRow[0].rowID) {           

                                                
                                                return {
                                                    ...el, 
                                                    productCode:selectedRows[0].productCode,
                                                    productID:selectedRows[0].productID,
                                                    productName:selectedRows[0].productName,
                                                    supplierCode:selectedRows[0].supplierCode,
                                                    productBarcode:selectedRows[0].productBarcode,
                                                    productPrice:selectedRows[0].productPrice,
                                                    productUnit:selectedRows[0].productUnit,
                                                    productOrdered:selectedRows[0].productOrdered,
                                                    ums:selectedRows[0].ums,
                                                    productStock:selectedRows[0].productStock,
                                                    discountPercent:0,
                                                    discount:0,
                                                    productQty:1,
                                                    edit:false,
                                            
                                                };
                                            }
                                            return el;  
                                        }));

                                        addProductRow(1)
                                    }
                                }
                                
                            }}

            
                        />
                    </Box>
                </div>
            </ModalAllder>
        
        </>
    )
}


const productList = [
    {
        "productID": 1,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 2,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 3,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 4,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 5,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 6,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 7,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 8,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    },
    {
        "productID": 9,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    }
    ,
    {
        "productID":10,
        "productCode": "16586235641",
        "productName": "กล่องขนมเค้กกลม ฐาน 16 นิ้ว",
        "productBarcode": "885112554663",
        "productCategory":"วัตถุดิบทำขนม",
        "productPrice":"70.00",
        "productUnit":"ชิ้น",
        "productRatio":"1 x 1",
        "supplierCode":"16586235641",
        "productOrdered":"50",
        "ums":"2,400",
        "productStock":"5,400"
    }

];